import React, { lazy } from 'react';
import { Link } from 'react-router-dom';
import { Instagram, ArrowRight, ShoppingBag } from 'lucide-react';
import { products } from '../data/products';
const ugcPosts = [{
  id: 1,
  image: 'https://images.unsplash.com/photo-1628840042765-356cda07504e?q=80&w=2080&auto=format&fit=crop',
  user: '@spicychef_nl',
  quote: 'De perfecte kick voor mijn pom! Kan niet meer zonder de Madame Jeanette vlokken.',
  productId: 1
}, {
  id: 2,
  image: 'https://images.unsplash.com/photo-1555939594-58d7cb561ad1?q=80&w=1974&auto=format&fit=crop',
  user: '@foodlover_amsterdam',
  quote: 'Fong Fong Pepre maakt deze curry helemaal af. Heerlijk authentiek!',
  productId: 2
}, {
  id: 3,
  image: 'https://images.unsplash.com/photo-1564834724105-918b73d1b9e0?q=80&w=1976&auto=format&fit=crop',
  user: '@surinaamskoken',
  quote: 'Altijd de juiste dosering hitte bij de hand. Ideaal voor doordeweeks.',
  productId: 1
}, {
  id: 4,
  image: 'https://images.unsplash.com/photo-1604908176997-125f25cc6f3d?q=80&w=1913&auto=format&fit=crop',
  user: '@bbq_master_nl',
  quote: 'Mijn secret ingredient voor de perfecte spicy marinade.',
  productId: 2
}];
export function Community() {
  return <section id="community" className="py-24 bg-brand-dark text-white" data-id="element-54">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-55">
        <div className="flex flex-col md:flex-row justify-between items-end mb-16 gap-6" data-id="element-56">
          <div className="max-w-2xl" data-id="element-57">
            <div className="flex items-center gap-2 text-brand-orange mb-4" data-id="element-58">
              <Instagram size={20} data-id="element-59" />
              <span className="font-medium tracking-widest uppercase text-sm" data-id="element-60">
                Community &amp; Flavor
              </span>
            </div>
            <h2 className="text-4xl md:text-5xl font-serif font-bold mb-6" data-id="element-61">
              Gedeelde Passie
            </h2>
            <p className="text-gray-400 text-lg" data-id="element-62">
              Ontdek hoe onze community Capsin gebruikt in hun favoriete
              gerechten. Deel jouw creatie met{' '}
              <span className="text-white font-medium" data-id="element-63">#Capsin</span> en word
              gefeatured!
            </p>
          </div>

          <a href="#" className="flex-shrink-0 flex items-center gap-2 border border-white/30 hover:border-white hover:scale-105 px-6 py-3 rounded-full transition-all" data-id="element-64">
            Volg ons op Instagram
            <ArrowRight size={16} data-id="element-65" />
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-66">
          {ugcPosts.map(post => {
          const product = products.find(p => p.id === post.productId);
          return <div key={post.id} className="group relative rounded-2xl overflow-hidden bg-gray-900 aspect-[4/5]" data-id="element-67">
                <img src={post.image} alt={`Gerecht van ${post.user}`} className="w-full h-full object-cover opacity-80 group-hover:opacity-100 group-hover:scale-105 transition-all duration-500" loading="lazy" data-id="element-68" />

                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent flex flex-col justify-end p-6" data-id="element-69">
                  <p className="text-sm font-medium text-brand-orange mb-2" data-id="element-70">
                    {post.user}
                  </p>
                  <p className="font-serif text-lg italic mb-6 line-clamp-3" data-id="element-71">
                    "{post.quote}"
                  </p>

                  {product && <Link to={`/product/${product.slug}`} className="w-full bg-white/10 hover:bg-brand-red backdrop-blur-sm text-white py-3 rounded-xl text-sm font-medium transition-colors flex items-center justify-center gap-2" data-id="element-72">
                      <ShoppingBag size={16} data-id="element-73" />
                      Shop de ingrediënten
                    </Link>}
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}